<template>
  <div>
    <div
      v-for="(pageIds, pageIndex) in pageGroupedProductsIds"
      :key="'page-' + pageIndex"
      class="position-relative dinA4"
    >
      <img
        :src="require('@/assets/peninsular-header.png')"
        class="mb-0 page__header"
      />
      <div v-for="productId in pageIds" :key="'product-' + productId">
        <div class="d-flex justify-center mb-4">
          <div>
            <img
              class="img-contain table-section-icon"
              :src="peninsularProducts[productId].imageUrl"
            />
          </div>
          <PdfProductTable
            type="peninsular"
            :tableData="productTableList[productId]"
            :tableId="productId"
          />
          <div class="ml-3 mt-3 small-letter-section">
            <p
              class="small-letter-font small-letter-font--bold mt-0 mb-0"
            >
              {{
                peninsularProducts[productId].title
                  ? peninsularProducts[productId].title
                  : 'Características del servicio'
              }}
            </p>
            <ul class="small-letter-font justify-text">
              <li
                v-for="(listElement, textIndex) in peninsularProducts[productId].text"
                :key="'listElement-' + textIndex"
                v-html="listElement"
              />
            </ul>
          </div>
        </div>
      </div>

      <Footer logo :page="previousPages + 1 + pageIndex" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2021/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2021/Footer'

export default {
  name: 'PeninsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      peninsularProducts: {
        '24H': {
          imageUrl: require('@/assets/ctt24-icon.png'),
          title: 'Características de los servicios Ctt 24h y Ctt e24h',
          text: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar pág. 10 de este documento).',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- El servicio Ctt e24h que disponga de teléfono móvil, se beneficiará GRATIS del <u>Preaviso de entrega</u>, el servicio de <u>Entrega flexible</u> y la <u>Predicción de franja horaria</u>.',
            '- Se admite la recogida y entrega en más de 200 puntos CTT Express con un servicio 24h sin coste adicional',
            '- El Servicio Peninsular y Peninsular + incluye la entrega en Portugal con más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
        '13h': {
          imageUrl: require('@/assets/ctt1330-icon.png'),
          title: 'Características del servicio Ctt 14:00h:',
          text: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar pág. 10 de este documento)',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Se admite la recogida y entrega en más de 200 puntos CTT Express con un servicio 24h sin coste adicional.',
            '- El Servicio Peninsular y Peninsular + incluye la entrega en Portugal con más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
        '10h': {
          imageUrl: require('@/assets/ctt10-icon.png'),
          title: 'Características del servicio Ctt 10:00h:',
          text: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Cobertura: Toda la Península Ibérica (consultar poblaciones con suplemento de kilometraje en www.cttexpress.com).',
            '- Se admite la recogida y entrega en más de 200 puntos CTT Express con un servicio 24h <u>sin coste adicional</u>.',
            '- El Servicio Peninsular y Peninsular + incluye la entrega en Portugal con más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
        '08h': {
          imageUrl: require('@/assets/ctt830-icon.png'),
          title: 'Características del servicio Ctt 8:30h:',
          text: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Cobertura: Capitales de provincia y otras poblaciones (consultar listado en <u>www.cttexpress.com</u>).',
            '- Se admite la recogida y entrega en más de 200 puntos CTT Express con un servicio 24h sin coste adicional.',
          ],
        },
        '48h': {
          imageUrl: require('@/assets/ctt48-icon.png'),
          title: 'Características de los servicios Ctt 48h y Ctt e48h:',
          text: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm.',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- El servicio Ctt e48h que disponga de teléfono móvil, se beneficiará GRATIS del <u>Preaviso de entrega</u>, el servicio de <u>Entrega flexible</u> y la <u>Predicción de franja horaria</u>.',
            '- Este servicio admite exceso de peso y exceso de medida (consultar pág. 10 de este documento).',
            '- El Servicio Peninsular y Peninsular + incluye la entrega en Portugal con más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
      },
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST]),
    peninsularProductsIds() {
      return Object.keys(this.peninsularProducts)
    },
    numberOfProducts() {
      return this.peninsularProductsIds.length
    },
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    pageGroupedProductsIds() {
      let pagesGroups = []
      let pageGroup = []
      let tripleRow = 0
      let doubleRow = 0

      const initializePageGroup = () => {
        pageGroup = []
        doubleRow = 0
        tripleRow = 0
      }

      for (const [index, productId] of this.peninsularProductsIds.entries()) {
        let numberOfRows = Object.keys(this.productTableList[productId].kgRows).length

        if (numberOfRows <= 7) {
          pageGroup.push(productId)

          tripleRow++
          if (tripleRow >= 3 || productId === this.numberOfProducts - 1 || doubleRow === 1) {
            pagesGroups.push(pageGroup)
            initializePageGroup()
          }

          if (this.peninsularProductsIds.length - 1 === index) {
            pagesGroups.push(pageGroup)
            initializePageGroup()
          }
        } else if (numberOfRows < 15) {
          pageGroup.push(productId)

          doubleRow++
          if (doubleRow >= 2 || productId === this.numberOfProducts - 1 || tripleRow === 1) {
            pagesGroups.push(pageGroup)
            initializePageGroup()
          }

          if (this.peninsularProductsIds.length - 1 === index) {
            pagesGroups.push(pageGroup)
            initializePageGroup()
          }
        } else {
          if (tripleRow > 0 || doubleRow > 0) {
            pagesGroups.push(pageGroup)
            initializePageGroup()
          }
          pageGroup.push(productId)
          pagesGroups.push(pageGroup)
          pageGroup = []
        }
      }
      return pagesGroups
    },
  },
  created() {
    this.$emit('updateTotalPages', { PeninsularTables: this.pageGroupedProductsIds.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('PeninsularTables')
  },
}
</script>
